<div id="task-form">
  <dk-toolbar-form
    *ngIf="!isCreateMode"
    [isEditing]="isEditing"
    titleClass="dx-form-group-caption"
    (editingCancelled)="handleCancelClick()"
    (editModeToggled)="handleEditClick()"
    (saveButtonClicked)="handleSaveClick($event)"
  >
  </dk-toolbar-form>

  <dx-form
    *ngIf="task"
    class="plain-styled-form"
    [class.view-mode]="!isEditing"
    [screenByWidth]="getSizeQualifier"
  >
    <dxi-item [visible]="isCreateMode">
      <div *dxTemplate>
        <dk-form-textbox
          label="Konu"
          [(value)]="task.text"
          [isEditing]="isEditing"
        ></dk-form-textbox>
      </div>
    </dxi-item>
    <dxi-item itemType="group">
      <dxo-col-count-by-screen
        [xs]="1"
        [sm]="2"
        [md]="2"
        [lg]="2"
      ></dxo-col-count-by-screen>
      <dxi-item cssClass="accent">
        <div *dxTemplate>
          <dk-form-textbox
            label="Firma"
            [(value)]="task.company"
            [isEditing]="isEditing"
          ></dk-form-textbox>
        </div>
      </dxi-item>

      <dxi-item cssClass="accent">
        <div *dxTemplate>
          <dk-form-textbox
            label="Atanan"
            [(value)]="task.owner"
            [isEditing]="isEditing"
          ></dk-form-textbox>
        </div>
      </dxi-item>

      <dxi-item>
        <div *dxTemplate>
          <dx-select-box
            label="Öncelik"
            stylingMode="filled"
            fieldTemplate="field"
            [(value)]="task.priority"
            [items]="priorityList"
            [readOnly]="!isEditing"
            [elementAttr]="{ class: 'form-editor' }"
          >
            <div *dxTemplate="let data of 'field'">
              <div>
                <dk-status-indicator
                  [showBar]="true"
                  [value]="task.priority"
                ></dk-status-indicator>
              </div>
            </div>

            <div *dxTemplate="let data of 'item'">
              <dk-status-indicator
                [showBar]="true"
                [isField]="false"
                [value]="data"
              ></dk-status-indicator>
            </div>
          </dx-select-box>
        </div>
      </dxi-item>

      <dxi-item>
        <div *dxTemplate>
          <dx-select-box
            label="Durum"
            stylingMode="filled"
            fieldTemplate="field"
            [(value)]="task.status"
            [items]="statusList"
            [readOnly]="!isEditing"
            [elementAttr]="{ class: 'form-editor' }"
          >
            <div *dxTemplate="let data of 'field'">
              <div>
                <dk-status-indicator
                  [value]="task.status"
                ></dk-status-indicator>
              </div>
            </div>

            <div *dxTemplate="let data of 'item'">
              <dk-status-indicator
                [isField]="false"
                [value]="data"
              ></dk-status-indicator>
            </div>
          </dx-select-box>
        </div>
      </dxi-item>

      <dxi-item>
        <div *dxTemplate>
          <dk-form-item-date
            label="Başlangıç Tarihi"
            text="Başlangıç Tarihi giriniz"
            [isEditing]="isEditing"
            [(value)]="task.startDate"
          ></dk-form-item-date>
        </div>
      </dxi-item>

      <dxi-item>
        <div *dxTemplate>
          <dk-form-item-date
            label="Bitiş Tarihi"
            text="Bitiş Tarihi giriniz"
            [isEditing]="isEditing"
            [(value)]="task.dueDate"
          ></dk-form-item-date>
        </div>
      </dxi-item>
    </dxi-item>
    <dxi-item>
      <div *dxTemplate>
        <dx-text-area
          label="Detay"
          stylingMode="filled"
          [readOnly]="!isEditing"
          [(value)]="task.description"
          [elementAttr]="{ class: 'form-editor' }"
        ></dx-text-area>
      </div>
    </dxi-item>
  </dx-form>

  <dx-load-panel
    content="#task-form"
    [visible]="!task || isLoading"
    [showPane]="false"
    [position]="{ of: '#task-form' }"
  ></dx-load-panel>
</div>
